const useDamageTypesLogic = () => {
  const apiRoute = "damagetypes";
  const onlyForm = undefined;

  const initFields = [
    {
      name: "name",
      label: "Damage Type Name",
      type: "text",
      isRequired: true,
      err: "Damage Type Name is required",
      showAction: false,
    },
    // Add more fields as needed
  ];

  //Roles
  const admin = process.env.REACT_APP_ADMIN_ROLE;
  const managerRole = process.env.REACT_APP_MANAGER_ROLE;
  const financeRole = process.env.REACT_APP_FINANCE_ROLE;
  ///Add,Delete,Edit Roles
  const addRoles = [admin, managerRole, financeRole];
  const deleteRoles = [admin, managerRole, financeRole];
  const editRoles = [admin, managerRole, financeRole];

  const getPromises = (temp) => {
    return [];
  };

  return {
    apiRoute,
    addRoles,
    editRoles,
    deleteRoles,
    initFields,
    getPromises,
    onlyForm,
  };
};

export default useDamageTypesLogic;
